import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IReadyTransacitonsToolbar {
	onStartProcessingButtonClickedHandler: () => void
	onDeleteButtonClickedHandler: () => void
	onPermanentDeleteButtonClickedHandler: () => void
}

export const ReadyTransacitonsToolbar: FC<IReadyTransacitonsToolbar> = ({
	onStartProcessingButtonClickedHandler,
	onDeleteButtonClickedHandler,
	onPermanentDeleteButtonClickedHandler
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					label="Start Processing"
					// type="submit"
					onClickHandler={onStartProcessingButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Permanent Delete"
					raised
					onClickHandler={onPermanentDeleteButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/>
			</Toolbar>
		</AppBar>
	);
};
